/* eslint-disable import/prefer-default-export */
import { SET_MERCHANT } from './types'

export const setMerchant = (merchant) => (dispatch) => {
  dispatch({ type: SET_MERCHANT, payload: merchant })
}
